var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPosition = function SvgMapPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2 8.666V2.833c0-.46.373-.833.833-.833h5.834M2 15.334v5.833c0 .46.373.834.833.834h5.834M22 8.666V2.833A.833.833 0 0 0 21.167 2h-5.834M22 15.334v5.833c0 .46-.373.834-.833.834h-5.834M7 11.998h10M12 17V7"
  })));
};
export default SvgMapPosition;